if ( window?.fritzScripts?.favoritesNonce ) {

	jQuery(document).ready(function($) {

		$(document).on('click', '.favorite-icon:not(.logged-in)', function(e) {
			// show a tooltip that says "Please log in to favorite this post."
			// if target it login link, do not prevent default
			if ($(e.target).is('#login-link')) {
				return;
			}
			e.preventDefault();
			var $icon = $(this);
			var tooltip = $('<div class="tooltip-favorite">Please <a id="login-link" href="/my-account">log in</a> to favorite this post.</div>');
			$icon.append(tooltip);
			setTimeout(function() {
				tooltip.fadeOut(500, function() {
					tooltip.remove();
				});
			}, 3000);
		});
		$(document).on('click', '.favorite-icon.logged-in', function(e) {
			e.preventDefault();
			var $icon = $(this);
			var post_id = $icon.data('post-id');

			$.post(fritzScripts.ajaxurl, {
				action: 'toggle_favorite',
				post_id: post_id,
			}, function(response) {
				if (response.success) {
					if ( $icon.hasClass('icon-favorited') ) {
						var tooltip = $('<div class="tooltip-favorite">Removed from favorites</div>');
						$icon.addClass('hidden');
						$icon.siblings('.icon-favorite').removeClass('hidden').append(tooltip);
						setTimeout(function() {
							tooltip.fadeOut(500, function() {
								tooltip.remove();
							});
						}, 2000);
					} else {
						var tooltip = $('<div class="tooltip-favorite">Added to favorites</div>');
						$icon.addClass('hidden');
						$icon.siblings('.icon-favorited').removeClass('hidden').append(tooltip);
						setTimeout(function() {
							tooltip.fadeOut(500, function() {
								tooltip.remove();
							});
						}, 2000);
					}
				}
			});
		});
	});
}